// 当前在移动端
export function getIsMobileUa() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}
